<div class="side-bar-content">
    <ul class="menu-list">
        <li>
            <a routerLink="/home/dashboard"   [ngClass]="{ activate: isItemActive('/home/dashboard') }">
                <div class="side-nav"></div>
                <img src="/assets/icons/prompt.svg" matTooltip="Dashboard" matTooltipPosition="right" alt=""/>

                @if (SideBarOpen){
                <span>Dashboard</span>
                }
            </a>
        </li>
        <li matTooltip="Gamification Board" matTooltipPosition="right"   [matTooltipClass]="{'custom-tooltip':SideBarOpen}">
            <a routerLink="/home/gamification-board" [ngClass]="{activate: isItemActive('/home/gamification-board')}">
                <div class="side-nav"></div>
                <img src="/assets/icons/social_leaderboard.svg" matTooltip="Gamification Board"
                    matTooltipPosition="right" alt="" />

                @if (SideBarOpen){
                <span>Gamification Board</span>
                }
            </a>
        </li>
       
        <li>
            <a  [href]="'https://mdigital.sharepoint.com/:f:/s/GAMEPlan734/Ei-ZPtJIQQNLn0QSqShYOw0BTSMF0NgA328pNBvmvBmdBw?e=2RsNoL'" target="_blank" rel="noopener noreferrer" (click)="setActiveExternalLink('User Guide  & Tutorials')"  [ngClass]="{'centerText':!SideBarOpen , 'activate': isExternalLinkActive('User Guide  & Tutorials')}">
                <div class="side-nav"></div>
                <img src="/assets/icons/school.svg" matTooltip="User Guide  & Tutorials" matTooltipPosition="right" alt="" />

                @if (SideBarOpen){
                <span>User Guide  & Tutorials</span>
                }
            </a>
        </li>
        <li>
            <a [href]="'https://forms.office.com/e/QJxY0WZiWU'"   target="_blank" rel="noopener noreferrer" (click)="setActiveExternalLink('Submit Feedback')" [ngClass]="{'centerText': !SideBarOpen, 'activate': isExternalLinkActive('Submit Feedback')}">
                <div class="side-nav"></div>
                <img src="/assets/icons/thumbs-up-down.svg" alt="" matTooltip="Submit Feedback" matTooltipPosition="right" />

                @if (SideBarOpen){
                <span>Submit Feedback</span>
                }
            </a>
        </li>
        <li>
            <a [href]="'https://mygpt-suite.uptimize.merckgroup.com/'" (click)="setActiveExternalLink('My GPT')"   target="_blank" rel="noopener noreferrer"  [ngClass]="{'centerText':!SideBarOpen, 'activate': isExternalLinkActive('My GPT')}">
                <div class="side-nav"></div>
                <img src="/assets/icons/my-gpt.svg" matTooltip="My GPT" matTooltipPosition="right" alt="" />

                @if (SideBarOpen){
                <span> My GPT </span>
                }
            </a>
        </li>
        <li *ngIf="user_role == 'admin'">
            @if (!SideBarOpen){
                <a href="#" (click)="preventRedirect($event)" class="admin-console" [ngClass]="{ activate: isItemActive(['home/model-configuration', 'home/user-configuration', 'home/prompt-configuration', 'home/category-management']) }">
                    <div class="side-nav"></div>
                    <img src="/assets/icons/admin_menu_img.svg" alt="admin"/>
                    <div class="admin-data">
                        <p style="padding: 0px 16px; color: #5E5E72; font-weight: 700; font-size: 14px; text-align: left;">Admin Console</p>
                        <mat-divider style="border-top-color: #E3E3E3;"></mat-divider>
                        <ul>
                            <li (click)="redirectPage('userMgmt')" [ngClass]="{ adminSubmenuActive: isItemActive('/home/user-configuration') }">User Management</li>
                            <li (click)="redirectPage('promptMgmt')" [ngClass]="{ adminSubmenuActive: isItemActive('/home/prompt-configuration') }">Prompt Management</li>
                            <li (click)="redirectPage('catMgmt')" [ngClass]="{ adminSubmenuActive: isItemActive('/home/category-management') }">Category Configuration</li>
                            <li (click)="redirectPage('modelMgmt')" [ngClass]="{ adminSubmenuActive: isItemActive('/home/model-configuration') }">Model Configuration</li>
                        </ul>
                    </div>
                </a>
                }
                @if (SideBarOpen){
                <mat-accordion>
                    <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)" [ngClass]="{ activate: isItemActive(['home/model-configuration', 'home/user-configuration', 'home/prompt-configuration', 'home/category-management'])}">
                        <mat-expansion-panel-header>
                            <mat-panel-title>   
                                <div class="side-nav" style="position: absolute; left: 0;"></div>
                                <div style="display: flex;">
                                    <img src="/assets/icons/admin_menu_img.svg" matTooltip="Admin Console" alt="" matTooltipPosition="right" style="width: 24px; height: 24px;"/>
                                    <p style="margin: 0px !important; padding: 0px 12px; font-family: 'Lato', sans-serif; color: #503291; font-weight: 700; font-size: 14px; font-style: normal;">Admin Console</p>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                    <p (click)="redirectPage('userMgmt')" class="cursor-pointer admin-sub-menu my-0" [ngClass]="{ adminSubmenuActive: isItemActive('/home/user-configuration') }">User Management</p>
                    <p (click)="redirectPage('promptMgmt')" class="cursor-pointer admin-sub-menu my-0" [ngClass]="{ adminSubmenuActive: isItemActive('/home/prompt-configuration') }">Prompt Management</p>
                    <p (click)="redirectPage('catMgmt')" class="cursor-pointer admin-sub-menu my-0" [ngClass]="{ adminSubmenuActive: isItemActive('/home/category-management') }">Category Configuration</p>
                    <p (click)="redirectPage('modelMgmt')" class="cursor-pointer admin-sub-menu my-0" [ngClass]="{ adminSubmenuActive: isItemActive('/home/model-configuration') }">Model Configuration</p>
                </mat-expansion-panel>
            </mat-accordion>    
            }
        </li>
        <li>
            <a [href]="'mailto:my_cocreator@merckgroup.com'" title="mailto:my_cocreator@merckgroup.com" [ngClass]="{'centerText':!SideBarOpen}">
                <div class="side-nav"></div>
                <img src="/assets/icons/support_Icon.svg" alt="" matTooltip="Support" matTooltipPosition="right" />

                @if (SideBarOpen){
                <span> Support </span>
                }
            </a>
        </li>
    </ul>
</div>